import { Client } from "@/Common/Api/Client";
import * as LocalOperations from "@/Common/Operations/operations.local";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";

interface IUrlEditProps {
    value: string;
    comonenetId?: string;
    urlValueCallBack?: string;
    employeeId?: string;
    className?: string;
}

class UrlEditState {
    constructor(state?: UrlEditState) {
        if (state == null) {
            this.formValid = false;
            this.validationDone = false;
            this.isDirty = false;
            this.tempValue = "";
            this.loading = false;
        }
        else {
            this.validationDone = state.validationDone;
            this.formValid = state.formValid;
            this.isDirty = state.isDirty;
            this.tempValue = state.tempValue;
            this.loading = state.loading;
        }
    }

    public formValid: boolean;
    public tempValue: string;
    public isDirty: boolean;
    public validationDone: boolean;
    public loading: boolean;
}

class UrlEdit extends React.Component<IUrlEditProps, UrlEditState> {
    private readonly client: Client = new Client();
    private readonly urlMatchingPattern: RegExp = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/;

    public constructor(props: IUrlEditProps) {
        super(props);

        const initialState = new UrlEditState();
        initialState.tempValue = this.props.value;
        this.state = initialState;
    }

    public render(): JSX.Element {
        var warningMsg = null;

        if (this.state.isDirty && !this.state.formValid && this.state.validationDone && this.state.tempValue.length > 0) {
            warningMsg = <small className="error">Url format not valid</small>;
        }

        var saveBtn = <a onClick={this.UpdateUrl.bind(this)}>{cacheStore.GetString("SaveButton")}</a>;
        if (this.state.loading) {
            saveBtn = null;
        }

        return (
            <div>
                <div className="row">
                    <div className="col-sm-12 col-md-8 col-lg-6">
                        <input
                            type="text"
                            className="form-control"
                            disabled={this.state.loading}
                            placeholder="type url"
                            onBlur={this.onFieldBlur.bind(this)}
                            onChange={this.setDirty.bind(this)}
                            value={this.state.tempValue}
                        />
                        {warningMsg}
                        <div style={{ margin: "10px 0 0" }}>
                            {saveBtn}
                        </div>
                    </div>
                </div>
            </div>

        );
    }

    public shouldComponentUpdate(): boolean {
        return true;
    }

    private setDirty(e: React.ChangeEvent<HTMLInputElement>): void {
        var val = e.target.value;
        var s = new UrlEditState(this.state);
        s.isDirty = true;
        s.validationDone = false;
        s.tempValue = val;
        this.setState(s);
    }

    private onFieldBlur(e: React.FocusEvent<HTMLInputElement>): void {
        var val = e.target.value;
        var pass = this.urlMatchingPattern.test(val);
        var s = new UrlEditState(this.state);
        s.validationDone = true;
        s.formValid = pass;
        this.setState(s);
    }

    private UpdateUrl(e: React.MouseEvent<HTMLAnchorElement>): void {
        e.preventDefault();
        var self = this;
        if (!this.state.formValid && this.state.isDirty && this.state.tempValue.length > 0) return;

        var s = new UrlEditState(this.state);
        s.loading = true;
        this.setState(s);

        this.client.Post(
            ServerOperations.Server.Configuration_UpdateEmployeeSettingsUsefulUrl,
            {
                EmployeeId: sessionStore.individualContactId,
                Url: self.state.tempValue
            },
            response => {
                if (response.Success) {
                    var operation = new LocalEvent(LocalOperations.SettingsUI.HideUrlEditControl);
                    operation.AddItem("url", self.state.tempValue);
                    LocalEventDispatcher.dispatch(operation);
                }
            },
            function() {
                var errorS = new UrlEditState(this.state);
                s.loading = false;
                this.setState(errorS);
            }
        );
    }
}

export { UrlEdit };
